export interface Movie {
  id: string;
  title: string;
  type: "电影" | "剧集" | "动画" | "纪录片";
  genres: string[];
  region: string;
  year: number;
  duration: string;
  episodes: number | null;
  recommend: string;
  synopsis: string;
  tags: string[];
  mode: ("在线观看" | "免费观看" | "高清播放" | "手机在线")[];
  poster: string;
}

export const movies: Movie[] = [
  {
    id: "m01",
    title: "星河迷航",
    type: "电影",
    genres: ["科幻", "冒险"],
    region: "内地",
    year: 2024,
    duration: "126 分钟",
    episodes: null,
    recommend: "编辑首选",
    synopsis:
      "一支远航勘测队在返航途中偏离航线，船上的导航系统记录下一段无法解释的信号。队员们在有限的补给与漫长的沉默中，需要决定是继续追查还是尽快归航。",
    tags: ["太空", "群像", "悬念"],
    mode: ["在线观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%20of%20a%20lone%20spacecraft%20drifting%20toward%20a%20glowing%20amber%20nebula%20in%20deep%20dark%20space%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-01&orientation=portrait",
  },
  {
    id: "m02",
    title: "雾都疑影",
    type: "剧集",
    genres: ["悬疑", "犯罪"],
    region: "内地",
    year: 2024,
    duration: "单集 45 分钟",
    episodes: 24,
    recommend: "本周热看",
    synopsis:
      "一座终年多雾的城市里，几桩看似独立的旧案在档案室的尘埃下重新浮现。一位不善言辞的档案管理员顺着被忽略的细节，逐步拼出被时间掩埋的关联。",
    tags: ["推理", "群像", "慢热"],
    mode: ["在线观看", "免费观看", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=rain%20slicked%20foggy%20city%20street%20at%20night%20with%20a%20solitary%20silhouette%20under%20a%20streetlamp%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-02&orientation=portrait",
  },
  {
    id: "m03",
    title: "山海拾光",
    type: "剧集",
    genres: ["奇幻", "东方"],
    region: "内地",
    year: 2023,
    duration: "单集 40 分钟",
    episodes: 30,
    recommend: "口碑连载",
    synopsis:
      "在典籍记载的奇异山川之间，一位年轻的拾光人负责收集散落各地的光与记忆。每集走过一处新的山野，也带回一个关于守护与告别的小故事。",
    tags: ["单元剧", "治愈", "传说"],
    mode: ["在线观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=mystical%20ancient%20oriental%20mountains%20floating%20above%20mist%20with%20glowing%20lanterns%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-03&orientation=portrait",
  },
  {
    id: "m04",
    title: "归途列车",
    type: "电影",
    genres: ["剧情", "公路"],
    region: "内地",
    year: 2023,
    duration: "112 分钟",
    episodes: null,
    recommend: "长片精选",
    synopsis:
      "一趟跨越多省的慢速列车，载着形形色色的旅人。列车长在一次临时停靠后，遇见了几位各自带着心事上车的乘客，旅途让陌生的他们慢慢靠近。",
    tags: ["旅途", "温情", "现实"],
    mode: ["在线观看", "免费观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20lonely%20passenger%20train%20crossing%20a%20vast%20golden%20plain%20at%20dusk%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-04&orientation=portrait",
  },
  {
    id: "m05",
    title: "霓虹旧梦",
    type: "剧集",
    genres: ["都市", "情感"],
    region: "港台",
    year: 2024,
    duration: "单集 42 分钟",
    episodes: 20,
    recommend: "新剧上线",
    synopsis:
      "老街区的霓虹招牌逐一亮起，又逐一亮灭。一位摄影师回到长大的街区，用镜头记录即将改造前的最后一个夏天，也重逢了多年未见的人。",
    tags: ["怀旧", "城市", "细腻"],
    mode: ["在线观看", "免费观看", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20lonely%20figure%20walking%20through%20warm%20neon%20reflections%20on%20a%20rainy%20old%20town%20street%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-05&orientation=portrait",
  },
  {
    id: "m06",
    title: "高原信使",
    type: "电影",
    genres: ["剧情", "纪实"],
    region: "内地",
    year: 2022,
    duration: "104 分钟",
    episodes: null,
    recommend: "人文推荐",
    synopsis:
      "在地广人稀的高原上，一位邮递员常年骑马往返于分散的牧点之间。他用一封封信把远方的消息带到家家户户，也在路上留下属于自己的足迹。",
    tags: ["高原", "守护", "质朴"],
    mode: ["在线观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20rider%20on%20horseback%20crossing%20a%20high%20plateau%20under%20dramatic%20warm%20clouds%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-06&orientation=portrait",
  },
  {
    id: "m07",
    title: "纸上王国",
    type: "动画",
    genres: ["动画", "冒险"],
    region: "内地",
    year: 2024,
    duration: "96 分钟",
    episodes: null,
    recommend: "亲子友好",
    synopsis:
      "在一座完全由折叠纸张构成的王国里，一位小女孩发现自己的画笔能让折痕变成道路。为了找回走散的伙伴，她在层层纸页间展开了一段奇妙的旅程。",
    tags: ["合家欢", "想象", "手绘"],
    mode: ["在线观看", "免费观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20whimsical%20paper%20cutout%20kingdom%20with%20folded%20origami%20castles%20glowing%20warm%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-07&orientation=portrait",
  },
  {
    id: "m08",
    title: "长夜灯塔",
    type: "剧集",
    genres: ["悬疑", "惊悚"],
    region: "海外",
    year: 2023,
    duration: "单集 48 分钟",
    episodes: 16,
    recommend: "高能追更",
    synopsis:
      "海岸边的灯塔每逢大雾便无人值守，可值班记录却从未中断。新来的看守在整理旧日志时，发现每隔数年就会出现同一种笔迹的留言。",
    tags: ["海岛", "谜团", "氛围"],
    mode: ["在线观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20tall%20lighthouse%20beam%20cutting%20through%20dense%20night%20fog%20by%20the%20rocky%20coast%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-08&orientation=portrait",
  },
  {
    id: "m09",
    title: "春风食肆",
    type: "剧集",
    genres: ["美食", "治愈"],
    region: "内地",
    year: 2024,
    duration: "单集 30 分钟",
    episodes: 12,
    recommend: "下饭首选",
    synopsis:
      "巷口一间不大的小馆，掌勺的老板记得每位熟客的口味。十二集里，十二道家常菜，也串起十二段发生在餐桌旁的小小故事。",
    tags: ["烟火气", "轻松", "短剧集"],
    mode: ["在线观看", "免费观看", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20cozy%20warm%20noodle%20shop%20interior%20with%20steam%20rising%20under%20golden%20lantern%20light%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-09&orientation=portrait",
  },
  {
    id: "m10",
    title: "逆流而上",
    type: "电影",
    genres: ["体育", "励志"],
    region: "内地",
    year: 2023,
    duration: "118 分钟",
    episodes: null,
    recommend: "热血推荐",
    synopsis:
      "一支不被看好的业余队伍，为了争取一次正式比赛的资格，从零开始重新训练。胜负之外，他们更在意的是能否让彼此都坚持到最后一场。",
    tags: ["团队", "成长", "赛场"],
    mode: ["在线观看", "免费观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20determined%20athlete%20running%20through%20warm%20golden%20dust%20at%20sunset%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-10&orientation=portrait",
  },
  {
    id: "m11",
    title: "深海回声",
    type: "电影",
    genres: ["科幻", "悬疑"],
    region: "海外",
    year: 2024,
    duration: "108 分钟",
    episodes: null,
    recommend: "视听体验",
    synopsis:
      "一艘科考潜航器驶入从未被探测的海沟。随着下潜深度增加，声呐捕捉到规律的回声，队员们开始怀疑那里并非空无一物。",
    tags: ["深海", "紧张", "科幻"],
    mode: ["在线观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20deep%20sea%20submersible%20descending%20into%20a%20glowing%20trench%20with%20amber%20particles%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-11&orientation=portrait",
  },
  {
    id: "m12",
    title: "古城匠人",
    type: "纪录片",
    genres: ["人文", "纪实"],
    region: "内地",
    year: 2023,
    duration: "单集 35 分钟",
    episodes: 8,
    recommend: "人文精选",
    synopsis:
      "镜头走进几位仍坚持手工技艺的匠人日常。从选料到成器，每一个慢下来的步骤，都记录着一门手艺如何在今天继续被需要。",
    tags: ["手艺", "慢节奏", "纪实"],
    mode: ["在线观看", "免费观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=an%20artisan%20crafting%20pottery%20in%20a%20warm%20old%20workshop%20with%20soft%20window%20light%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-12&orientation=portrait",
  },
  {
    id: "m13",
    title: "星野南行",
    type: "剧集",
    genres: ["青春", "旅行", "治愈"],
    region: "内地",
    year: 2024,
    duration: "单集 38 分钟",
    episodes: 18,
    recommend: "轻松追剧",
    synopsis:
      "四位刚毕业的朋友把攒下的假期拼在一起，驾车一路向南。沿途的星空、陌生人和临时改变的计划，让这趟旅行比想象中走得更远。",
    tags: ["公路", "友情", "治愈"],
    mode: ["在线观看", "免费观看", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=young%20travelers%20under%20a%20vast%20starry%20sky%20beside%20a%20campfire%20on%20a%20warm%20night%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-13&orientation=portrait",
  },
  {
    id: "m14",
    title: "荒原守望者",
    type: "电影",
    genres: ["剧情", "西部"],
    region: "海外",
    year: 2022,
    duration: "122 分钟",
    episodes: null,
    recommend: "气质长片",
    synopsis:
      "荒原边缘的一座旧驿站里，最后一位守望者守着一条早已少有人走的商路。一个陌生人的到来，让平静的日子起了变化。",
    tags: ["荒原", "孤独", "对峙"],
    mode: ["在线观看", "高清播放", "手机在线"],
    poster:
      "https://readdy.ai/api/search-image?query=a%20lone%20figure%20on%20a%20horse%20facing%20a%20vast%20warm%20desert%20canyon%20at%20golden%20hour%2C%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20soft%20lighting%2C%20subtle%20film%20grain%2C%20premium%20streaming%20poster%20aesthetic%2C%20clean%20minimal%20composition&width=600&height=900&seq=sc-poster-14&orientation=portrait",
  },
];